import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "../../../../languages/index";
import _ from "lodash";
import renderHTML from "react-render-html";

// Import Component
import CommonHeaderLegalDocs from "../commonheaderlegaldocs.js";
//Import action
import { fetchSettingsMaster } from "../../actions/index";
// Import BaseLoader
import Loader from "../../../../components/Common/loader";

class LegalDocsTermsNCons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      loaderDesc: LocaleStrings.preparing_legal_docs,
    };

    // All Binded Functions
  }

  //Arrow function for renderLoader
  componentDidMount() {
    this.props.fetchSettingsMaster(this.props.session, (callback) => {
      this.setState({ loading: false });
    });
    window.scrollTo(0, 0);
  }

  render() {
    let { settingsMasterConsumer, language } = this.props;

    let dataContent = "";

    if (!_.isEmpty(settingsMasterConsumer)) {
      dataContent =
        language === "en"
          ? settingsMasterConsumer.terms_conditions_en
          : settingsMasterConsumer.terms_conditions_ar;
    }

    return (
      <>
        <div className="bg-newarrival pl-3 md:pl-5 lg:px-89 xl:px-139 2xl:px-298 pr-3 md:pr-5 pb-25">
          <div className="grid grid-cols-1 pt-25">
            <div className="bg-white rounded p-5">
              {window.location.search &&
              (window.location.search == "?origin=consumer" ||
                window.location.search == "?origin=vendor") ? (
                ""
              ) : (
                <CommonHeaderLegalDocs
                  history={this.props.history}
                  commonHeaderText={
                    LocaleStrings.consumer_legal_docs_list_text1
                  }
                />
              )}
              {/* <div className="policyHeader">
                <p className="text-xl font-medium">
                  {LocaleStrings.consumer_legal_docs_list_text1}
                </p>
                <p className="font-normal">
                  {LocaleStrings.consumer_legal_docs_list_subtext1}
                </p>
              </div> */}
              {this.state.loading ? (
                <>
                  <Loader />
                </>
              ) : (
                <div className="p-1 bg-white text-justify">
                  {/* {renderHTML(dataContent)} */}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: dataContent,
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.isLoggedIn,
    user: state.user,
    session: state.session,
    language: state.localLanguage,
    settingsMasterConsumer: state.settingsMasterConsumer
      ? state.settingsMasterConsumer.data !== "undefined"
        ? state.settingsMasterConsumer.data
        : []
      : [],
  };
}

export default connect(mapStateToProps, {
  fetchSettingsMaster,
})(LegalDocsTermsNCons);
